import React from 'react'
import { BookOpen, Mic, Users, Award, ArrowRight, Play, Star, Calendar } from 'lucide-react'

const Home = () => {
  const services = [
    {
      icon: BookOpen,
      title: 'Publish',
      description: 'Become a bestselling author and establish your authority through powerful storytelling and proven publishing strategies.'
    },
    {
      icon: Mic,
      title: 'Speak',
      description: 'Share your signature message with the masses through speaking engagements, podcasts, and media appearances.'
    },
    {
      icon: Users,
      title: 'Prosper',
      description: 'Transform your expertise into a thriving business with our proven system for generating overflowing abundance.'
    }
  ]

  const achievements = [
    { number: '6x', label: 'Bestselling Author' },
    { number: '27+', label: 'Podcast Episodes' },
    { number: '100+', label: 'Clients Transformed' },
    { number: '#1', label: 'Ranked Sales Teams' }
  ]

  const podcastEpisodes = [
    {
      title: 'Prosper from Your Lead Generation in 2025',
      guest: 'Dr. Minnie Gupta',
      duration: '12:50'
    },
    {
      title: 'Vision as Your GPS: Designing Life',
      guest: 'Val Mulan',
      duration: '31:45'
    },
    {
      title: 'Turning Passions into Profit',
      guest: 'Matt McWilliams',
      duration: '16:00'
    }
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/Home.jsx" data-component-line="1:1" data-component-id="client/src/pages/Home.jsx:1:1">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white overflow-hidden" data-component-path="client/src/pages/Home.jsx" data-component-line="2:2" data-component-id="client/src/pages/Home.jsx:2:2">
        <div className="absolute inset-0 bg-black/20" data-component-path="client/src/pages/Home.jsx" data-component-line="3:3" data-component-id="client/src/pages/Home.jsx:3:3"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 relative z-10" data-component-path="client/src/pages/Home.jsx" data-component-line="4:4" data-component-id="client/src/pages/Home.jsx:4:4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/Home.jsx" data-component-line="5:5" data-component-id="client/src/pages/Home.jsx:5:5">
            <div data-component-path="client/src/pages/Home.jsx" data-component-line="6:6" data-component-id="client/src/pages/Home.jsx:6:6">
              <div className="inline-flex items-center gap-2 bg-blue-700/50 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="7:7" data-component-id="client/src/pages/Home.jsx:7:7">
                <Award className="w-5 h-5 text-yellow-400 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="8:8" data-component-id="client/src/pages/Home.jsx:8:8" />
                <span className="text-sm font-semibold" data-component-path="client/src/pages/Home.jsx" data-component-line="9:9" data-component-id="client/src/pages/Home.jsx:9:9">6x Award-Winning Bestselling Author</span>
              </div>
              <h1 className="font-display font-black text-5xl md:text-6xl lg:text-7xl mb-6 leading-tight" data-component-path="client/src/pages/Home.jsx" data-component-line="10:10" data-component-id="client/src/pages/Home.jsx:10:10">
                Transform Your Voice Into Authority
              </h1>
              <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="11:11" data-component-id="client/src/pages/Home.jsx:11:11">
                Discover the power of your story. Become a bestselling author and share your signature message with the world through the proven Publish-Speak-Prosper system.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-component-path="client/src/pages/Home.jsx" data-component-line="12:12" data-component-id="client/src/pages/Home.jsx:12:12">
                <a
                  href="https://calendly.com/terrypaul-llc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-14 px-8 bg-yellow-500 text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="13:13"
                  data-component-id="client/src/pages/Home.jsx:13:13"
                >
                  <Calendar className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="14:14" data-component-id="client/src/pages/Home.jsx:14:14" />
                  Book Your Free 15-Min Call
                </a>
                <a
                  href="https://skyrockettosuccess.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-14 px-8 bg-white/10 backdrop-blur-sm border-2 border-white text-white font-bold rounded-lg hover:bg-white/20 transition-all duration-200 flex items-center justify-center gap-2"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="15:15"
                  data-component-id="client/src/pages/Home.jsx:15:15"
                >
                  <Play className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="16:16" data-component-id="client/src/pages/Home.jsx:16:16" />
                  Listen to Podcast
                </a>
              </div>
            </div>
            <div className="relative" data-component-path="client/src/pages/Home.jsx" data-component-line="17:17" data-component-id="client/src/pages/Home.jsx:17:17">
              <img
                src="https://images.pexels.com/photos/2422294/pexels-photo-2422294.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Professional speaker on stage"
                className="rounded-2xl shadow-2xl w-full h-auto"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=1200'
                }}
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="18:18"
                data-component-id="client/src/pages/Home.jsx:18:18"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-white py-16" data-component-path="client/src/pages/Home.jsx" data-component-line="19:19" data-component-id="client/src/pages/Home.jsx:19:19">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="20:20" data-component-id="client/src/pages/Home.jsx:20:20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="21:21" data-component-id="client/src/pages/Home.jsx:21:21">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center" data-component-path="client/src/pages/Home.jsx" data-component-line="22:22" data-component-id="client/src/pages/Home.jsx:22:22">
                <div className="font-display font-black text-5xl text-blue-600 mb-2" data-component-path="client/src/pages/Home.jsx" data-component-line="23:23" data-component-id="client/src/pages/Home.jsx:23:23">
                  {achievement.number}
                </div>
                <div className="text-gray-600 font-semibold" data-component-path="client/src/pages/Home.jsx" data-component-line="24:24" data-component-id="client/src/pages/Home.jsx:24:24">
                  {achievement.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Publish-Speak-Prosper Section */}
      <section className="bg-gray-50 py-20" data-component-path="client/src/pages/Home.jsx" data-component-line="25:25" data-component-id="client/src/pages/Home.jsx:25:25">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="26:26" data-component-id="client/src/pages/Home.jsx:26:26">
          <div className="text-center mb-16" data-component-path="client/src/pages/Home.jsx" data-component-line="27:27" data-component-id="client/src/pages/Home.jsx:27:27">
            <h2 className="font-display font-black text-4xl md:text-5xl text-gray-900 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="28:28" data-component-id="client/src/pages/Home.jsx:28:28">
              The Publish-Speak-Prosper System
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="29:29" data-component-id="client/src/pages/Home.jsx:29:29">
              A proven framework to help you turn your expertise into authority and build a thriving business
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="30:30" data-component-id="client/src/pages/Home.jsx:30:30">
            {services.map((service, index) => {
              const Icon = service.icon
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="31:31"
                  data-component-id="client/src/pages/Home.jsx:31:31"
                >
                  <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="32:32" data-component-id="client/src/pages/Home.jsx:32:32">
                    <Icon className="w-8 h-8 text-blue-600 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="33:33" data-component-id="client/src/pages/Home.jsx:33:33" />
                  </div>
                  <h3 className="font-display font-bold text-2xl text-gray-900 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="34:34" data-component-id="client/src/pages/Home.jsx:34:34">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="35:35" data-component-id="client/src/pages/Home.jsx:35:35">
                    {service.description}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Featured Book Section */}
      <section className="bg-white py-20" data-component-path="client/src/pages/Home.jsx" data-component-line="36:36" data-component-id="client/src/pages/Home.jsx:36:36">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="37:37" data-component-id="client/src/pages/Home.jsx:37:37">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/Home.jsx" data-component-line="38:38" data-component-id="client/src/pages/Home.jsx:38:38">
            <div data-component-path="client/src/pages/Home.jsx" data-component-line="39:39" data-component-id="client/src/pages/Home.jsx:39:39">
              <img
                src="https://images.pexels.com/photos/1029141/pexels-photo-1029141.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Death of a Yellow Page Salesman book"
                className="rounded-2xl shadow-2xl w-full max-w-md mx-auto"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/159866/books-book-pages-read-literature-159866.jpeg?auto=compress&cs=tinysrgb&w=800'
                }}
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="40:40"
                data-component-id="client/src/pages/Home.jsx:40:40"
              />
            </div>
            <div data-component-path="client/src/pages/Home.jsx" data-component-line="41:41" data-component-id="client/src/pages/Home.jsx:41:41">
              <div className="inline-flex items-center gap-2 bg-yellow-100 px-4 py-2 rounded-full mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="42:42" data-component-id="client/src/pages/Home.jsx:42:42">
                <Star className="w-5 h-5 text-yellow-600 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="43:43" data-component-id="client/src/pages/Home.jsx:43:43" />
                <span className="text-sm font-semibold text-yellow-900" data-component-path="client/src/pages/Home.jsx" data-component-line="44:44" data-component-id="client/src/pages/Home.jsx:44:44">Featured Book</span>
              </div>
              <h2 className="font-display font-black text-4xl md:text-5xl text-gray-900 mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="45:45" data-component-id="client/src/pages/Home.jsx:45:45">
                Death of a Yellow Page Salesman
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="46:46" data-component-id="client/src/pages/Home.jsx:46:46">
                From Lost to Found — Filled to Overflowing. A powerful story of transformation and resilience in the face of industry disruption.
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="47:47" data-component-id="client/src/pages/Home.jsx:47:47">
                When Google killed the Yellow Pages industry, Paul T. Neustrom didn't just survive—he thrived. This book shares the career lessons and breakthrough moments that led to the creation of the Publish-Speak-Prosper system, helping professionals turn disruption into opportunity.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-component-path="client/src/pages/Home.jsx" data-component-line="48:48" data-component-id="client/src/pages/Home.jsx:48:48">
                <a
                  href="https://www.barnesandnoble.com/w/death-of-a-yellow-page-salesman-paul-t-neustrom/1143280718"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-11 px-6 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="49:49"
                  data-component-id="client/src/pages/Home.jsx:49:49"
                >
                  <BookOpen className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="50:50" data-component-id="client/src/pages/Home.jsx:50:50" />
                  Get the Book
                </a>
                <a
                  href="https://paulbestsellers.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-11 px-6 bg-gray-100 text-gray-900 font-semibold rounded-lg hover:bg-gray-200 transition-all duration-200 flex items-center justify-center gap-2"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="51:51"
                  data-component-id="client/src/pages/Home.jsx:51:51"
                >
                  View All Books
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Podcast Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-20" data-component-path="client/src/pages/Home.jsx" data-component-line="52:52" data-component-id="client/src/pages/Home.jsx:52:52">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="53:53" data-component-id="client/src/pages/Home.jsx:53:53">
          <div className="text-center mb-12" data-component-path="client/src/pages/Home.jsx" data-component-line="54:54" data-component-id="client/src/pages/Home.jsx:54:54">
            <div className="inline-flex items-center gap-2 bg-blue-600/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="55:55" data-component-id="client/src/pages/Home.jsx:55:55">
              <Mic className="w-5 h-5 text-blue-400 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="56:56" data-component-id="client/src/pages/Home.jsx:56:56" />
              <span className="text-sm font-semibold" data-component-path="client/src/pages/Home.jsx" data-component-line="57:57" data-component-id="client/src/pages/Home.jsx:57:57">Podcast</span>
            </div>
            <h2 className="font-display font-black text-4xl md:text-5xl mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="58:58" data-component-id="client/src/pages/Home.jsx:58:58">
              Skyrocket to Success
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="59:59" data-component-id="client/src/pages/Home.jsx:59:59">
              Share Your Signature Message with the Masses! Featuring entrepreneurs who are dominating their space.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-component-path="client/src/pages/Home.jsx" data-component-line="60:60" data-component-id="client/src/pages/Home.jsx:60:60">
            {podcastEpisodes.map((episode, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300"
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="61:61"
                data-component-id="client/src/pages/Home.jsx:61:61"
              >
                <div className="flex items-center gap-3 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="62:62" data-component-id="client/src/pages/Home.jsx:62:62">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="63:63" data-component-id="client/src/pages/Home.jsx:63:63">
                    <Play className="w-6 h-6" data-component-path="client/src/pages/Home.jsx" data-component-line="64:64" data-component-id="client/src/pages/Home.jsx:64:64" />
                  </div>
                  <span className="text-sm text-gray-300" data-component-path="client/src/pages/Home.jsx" data-component-line="65:65" data-component-id="client/src/pages/Home.jsx:65:65">{episode.duration}</span>
                </div>
                <h3 className="font-bold text-lg mb-2" data-component-path="client/src/pages/Home.jsx" data-component-line="66:66" data-component-id="client/src/pages/Home.jsx:66:66">{episode.title}</h3>
                <p className="text-gray-300 text-sm" data-component-path="client/src/pages/Home.jsx" data-component-line="67:67" data-component-id="client/src/pages/Home.jsx:67:67">with {episode.guest}</p>
              </div>
            ))}
          </div>

          <div className="text-center" data-component-path="client/src/pages/Home.jsx" data-component-line="68:68" data-component-id="client/src/pages/Home.jsx:68:68">
            <a
              href="https://skyrockettosuccess.com"
              target="_blank"
              rel="noopener noreferrer"
              className="h-14 px-8 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl inline-flex items-center justify-center gap-2"
              data-component-path="client/src/pages/Home.jsx"
              data-component-line="69:69"
              data-component-id="client/src/pages/Home.jsx:69:69"
            >
              Listen to All Episodes
              <ArrowRight className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="70:70" data-component-id="client/src/pages/Home.jsx:70:70" />
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="bg-blue-600 py-20" data-component-path="client/src/pages/Home.jsx" data-component-line="71:71" data-component-id="client/src/pages/Home.jsx:71:71">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Home.jsx" data-component-line="72:72" data-component-id="client/src/pages/Home.jsx:72:72">
          <h2 className="font-display font-black text-4xl md:text-5xl text-white mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="73:73" data-component-id="client/src/pages/Home.jsx:73:73">
            Ready to Transform Your Career?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="74:74" data-component-id="client/src/pages/Home.jsx:74:74">
            Book a free 15-minute consultation and discover how the Publish-Speak-Prosper system can help you build authority and grow your business.
          </p>
          <a
            href="https://calendly.com/terrypaul-llc"
            target="_blank"
            rel="noopener noreferrer"
            className="h-14 px-8 bg-yellow-500 text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-all duration-200 shadow-lg hover:shadow-xl inline-flex items-center justify-center gap-2"
            data-component-path="client/src/pages/Home.jsx"
            data-component-line="75:75"
            data-component-id="client/src/pages/Home.jsx:75:75"
          >
            <Calendar className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="76:76" data-component-id="client/src/pages/Home.jsx:76:76" />
            Book Your Free Call Now
          </a>
        </div>
      </section>
    </div>
  )
}

export default Home